import Icons from "../../../components/icons";
import { useUsersContext } from "../../../context/usersContext";

const AuthTopBar = () => {
  const { agency } = useUsersContext();
  return (
    <div className="w-full py-4 px-3 bg-background border-b border-border">
      {agency?.Customization?.logo ? (
        <img
          src={agency?.Customization?.logo}
          alt="logo"
          className="dark:invert"
          style={{ maxWidth: "98px", maxHeight: "28px", paddingLeft: "10px" }}
        />
      ) : (
        <span className="inline-flex dark:invert">
          <Icons id="maybeIcon" />
        </span>
      )}
    </div>
  );
};

export default AuthTopBar;
